import { Typography } from "@mui/material"
import CarType from "../../interfaces/car"
import CardSearchItem from "./CardSearchItem"
import { useTranslation } from "react-i18next"

type PropsType = {
    cars: CarType[],
    loading: boolean,
}
export default function CardSearchList({ cars, loading }: PropsType) {
    const { t } = useTranslation()
    return (
        <div className="flex flex-col gap-4">
            {
                loading ?
                    [undefined, undefined, undefined].map((car, index) => (
                        <CardSearchItem key={index} car={car} />
                    ))
                    :
                    (
                        cars.length ?
                            cars.map((car, index) => (
                                <CardSearchItem key={index} car={car} />
                            ))
                            :
                            <Typography className="w-full text-center">{t('search_no_result')}</Typography>
                    )
            }
        </div>
    )
}
